import { Component, OnInit } from '@angular/core';
import { forkJoin, of } from 'rxjs';
import Swal from 'sweetalert2';
import { AuthService } from '../../../core/auth.service';
import { StaffService } from '../staff.service';

@Component({
  selector: 'app-staff-operations',
  templateUrl: './staff-operations.component.html',
  styleUrls: ['./staff-operations.component.scss']
})
export class StaffOperationsComponent implements OnInit {
  loading = false;
  staff: any[] = [];
  requests: any[] = [];
  inbox: any[] = [];
  sent: any[] = [];

  constructor(
    private staffService: StaffService,
    private auth: AuthService
  ) {}

  ngOnInit(): void {
    this.loadOperations();
  }

  loadOperations(): void {
    this.loading = true;
    forkJoin({
      staff: this.canViewStaffDirectory() ? this.staffService.getAll() : of([]),
      requests: this.canViewRequests() ? this.staffService.getAllRequests() : of([]),
      inbox: this.canViewMessages() ? this.staffService.getInboxMessages() : of([]),
      sent: this.canViewMessages() ? this.staffService.getSentMessages() : of([])
    }).subscribe({
      next: ({ staff, requests, inbox, sent }) => {
        this.staff = staff || [];
        this.requests = requests || [];
        this.inbox = inbox || [];
        this.sent = sent || [];
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        Swal.fire('Error', err?.error?.message || 'Failed to load staff operations.', 'error');
      }
    });
  }

  get pendingRequests(): any[] {
    return this.requests.filter((row) => String(row?.status || '').toLowerCase() === 'pending');
  }

  get approvedRequests(): number {
    return this.requests.filter((row) => String(row?.status || '').toLowerCase() === 'approved').length;
  }

  get rejectedRequests(): number {
    return this.requests.filter((row) => String(row?.status || '').toLowerCase() === 'rejected').length;
  }

  get inactiveStaff(): any[] {
    return this.staff.filter((row) => !row?.isActive).slice(0, 6);
  }

  get profileGaps(): any[] {
    return this.staff.filter((row) => !row?.department || !row?.position).slice(0, 6);
  }

  get responseLoad(): Array<{ label: string; value: number }> {
    return [
      { label: 'Inbox Threads', value: this.inbox.length },
      { label: 'Unread Inbox', value: this.inbox.filter((row) => !row?.isRead).length },
      { label: 'Sent Threads', value: this.sent.length },
      { label: 'Open Conversations', value: this.sent.filter((row) => !row?.isClosed).length }
    ];
  }

  get latestPendingRequests(): any[] {
    return [...this.pendingRequests]
      .sort((a, b) => new Date(b.requestedAt || 0).getTime() - new Date(a.requestedAt || 0).getTime())
      .slice(0, 8);
  }

  private canViewStaffDirectory(): boolean {
    return this.auth.hasAnyPermission(['staff.view', 'staff.manage']);
  }

  private canViewRequests(): boolean {
    return this.auth.hasAnyPermission(['staff.request.view', 'staff.request.approve', 'staff.manage']);
  }

  private canViewMessages(): boolean {
    return this.auth.hasAnyPermission(['staff.message.view', 'staff.message.send', 'staff.manage']);
  }
}
